import {types} from '../../types';

const setGetBonusesPersonalAction = (payload) => {
    return {
        type: types.personal.SET_PERSONAL_BONUSES,
        payload,
      }
}

const setGetBonusesHistoryAction = (payload) => {
  return {
    type: types.personal.SET_HISTORY_BONUSES,
    payload
  }
}

export {
  setGetBonusesPersonalAction as SetGetBonusesPersonalAction,
  setGetBonusesHistoryAction as SetGetBonusesHistoryAction
}